import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sidebarCollapsed: false,
    token:localStorage.getItem('token') || '',
    user:null,
    ws:null,
    platform:null,

  },
  getters:{
    token: state => state.token,
    userInfo: state => state.user,
    ws:state=>state.ws,
    platform:state=>state.platform,

  },
  mutations: {
    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    SET_TOKEN(state, val) {
      state.token = val
      localStorage.setItem('token', val)
    },
    // 保存用户信息
    SET_USER(state, info) {
      state.user = info
    },
    // 清空登录信息
    LOGOUT(state) {
      state.token = ''
      localStorage.removeItem('token')
      state.user = null
    },
    SET_WS(state,url){
      state.ws=url;
    },
    SET_PLATFORM(state,info){
      state.platform=info
    },



  },
  actions: {


    setWs({commit},url){
      commit("SET_WS",url)

    },
    setPlatform({commit},info){

      commit("SET_PLATFORM",info);
    },
    toggleSidebar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    setToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setUser({ commit }, info) {
      commit('SET_USER', info)
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
  },
  modules: {}
})
